import moment from 'moment';
let searchDate = moment().startOf('year').format('YYYY');
export default {
	searchParams: SEARCH_PARAMS(),
	pcRoListScrId: '', //ro리스트 화면 ID
	pmcSaleListScrId: '', //PMC 판매정보화면 ID
	pagingInfo: PAGING_INFO(), //페이지 정보

	carScnList: [], //검색 차량구분 셀렉트박스
	pacScnList: [], //검색 승상구분 셀렉트박스
	partTypeList: [], //검색 부품유형 셀렉트박스
	plntCdList: [], //검색 생산공장 셀렉트박스
	flclSpcList: [], //검색 연료전지사양 셀렉트박스
	saleNatList: [], //검색 판매국가 셀렉트박스
	occuRegnList: [], //검색 판매지역 셀렉트박스
	customPrCorList: [], //검색 생산법인 커스텀 셀렉트박스
	carTypeNmList: [], //검색 차종유형 셀렉트박스

	grdSalesList: [], //그리드리스트
	dayCols: [], //그리드 컬럼(년월컬럼)

	graphBarStackChartInfo: [], //그래프 스택 임시저장소
	graphLineChartInfo: [], //라인차트 임시저장소
	m3IdxScnList: [], //조회구분(1m,2m,3m)

	lcMaxVal: '', //라인차트 Y축 최대값 추가
	bcMaxVal: '', //바차트 Y축 최대값 추가
	isLoading: false //추가
};

function SEARCH_PARAMS() {
	return {
		partType: '', //부품유형
		carScn: '', //차량구분
		pacScn: '', //승상구분
		//customPrCor: '', //생산법인
		//plntCd: '', //생산공장
		flclSpc: '', //연료전지사양
		//saleNat: '', //판매국가
		occuRegn: '', //판매지역
		carTypeNm: '', //차종유형
		m1: '', //체크박스1M
		m2: '', //체크박스2M
		m3: '', //체크박스3M
		m3IdxScn: '',
		searchDate: searchDate //기준년도
	};
}

function PAGING_INFO() {
	return {
		currentPage: 1,
		endPage: 1,
		pageUnit: 10,
		startPage: 1,
		totalSize: 1
	};
}

export { SEARCH_PARAMS, PAGING_INFO };
